import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon } from '@livable/saas-react-components';
import { Button, Divider, Menu, Link } from '@mui/material';
export const PaymentsAndSubscriptionsMenu = observer(_ref => {
  let handleOpenRefundCreditInvoiceModal = _ref.handleOpenRefundCreditInvoiceModal,
    setModalInvoice = _ref.setModalInvoice,
    invoiceLink = _ref.invoiceLink,
    isDisabledRefund = _ref.isDisabledRefund,
    isDisabledInvoice = _ref.isDisabledInvoice;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined
    // disabled={!(invoiceLink || !isDisabledInvoice || !isDisabledRefund)}
    ,
    'custom-attribute': '441-resident-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    'custom-attribute': '82-active-building-menu'
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: invoiceLink,
    target: "_blank",
    variant: "menuAction",
    disabled: !invoiceLink || isDisabledInvoice
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), t('Download invoice')), (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: isDisabledRefund,
    onClick: () => {
      handleClose();
      setModalInvoice();
      handleOpenRefundCreditInvoiceModal();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "auto-pay"
  }), t('Refund/Credit')))));
});